import { render, staticRenderFns } from "./purchasePlanList.vue?vue&type=template&id=942592a0&scoped=true&"
import script from "./purchasePlanList.vue?vue&type=script&lang=js&"
export * from "./purchasePlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942592a0",
  null
  
)

component.options.__file = "purchasePlanList.vue"
export default component.exports